import styled from 'styled-components';
import { Modal } from 'antd';

export const LockTemplateModal = styled(Modal)`
  font-family: 'Open Sans', sans-serif;
  .ant-modal-title {
    font-weight: 700;
    font-size: 20px;
  }
  .ant-modal-body {
    text-align: center;
  }
  h4 {
    padding-top: 8px;
  }
`;
